/* eslint-disable no-void */

import { cache } from 'react';
import type { ReviewSummary, YourReviewAnswers } from 'types/testFreaks';

import { getMarketConfigFromCode } from '@/config/market-configurations';

import { sortReviews } from './sortReviews';

export const DEFAULT_SORT_OPTION = 'relevance';

// TODO: change limit to 3,5 instead of 1. 1 is for test purposes
export const getProductReviews = cache(
    async ({ productId, market }: { productId: string; market: string }) => {
        const marketConfig = getMarketConfigFromCode(market);
        const clientId = marketConfig.testfreaksClientId;
        try {
            if (!clientId) {
                throw new Error('Missing testfreaks ID');
            }
            const response = await fetch(
                `https://js.testfreaks.com/onpage/${clientId}/reviews.json?url_key=${productId}&limit=${100}&sort=date:asc`,
            );

            if (!response.ok) {
                const message = await response.text();
                throw new Error(message);
            }
            const summary: ReviewSummary = await response.json();

            if (summary?.your_review_url) {
                const reviewResponse = await fetch(summary.your_review_url);
                if (!reviewResponse.ok) return { summary };
                const your_review_answers: YourReviewAnswers =
                    await reviewResponse.json();

                sortReviews(your_review_answers.reviews);

                return { summary, your_review_answers };
            }
            return { summary };
        } catch (e: any) {
            console.error(e, 'Unable to fetch product reviews');
            return undefined;
        }
    },
);
